import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme: { token } }) => token.marginLG}px;
  padding: ${({ theme: { token } }) => token.paddingXL}px 0px ${({ theme: { token } }) => token.padding}px 0px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;